<template>
    <div class="login-main">
        <div class="login-bg">
            <p>评审签到系统</p>
        </div>
        <div class="login-form">
            <van-row>
                <van-col :span="24" class="login-input">
                    <van-cell-group>
                        <van-field clearable v-model="form.username" placeholder="请输入账号" />
                        <img class="phoneicon" src="@/assets/images/login-phone.png" alt="" />
                    </van-cell-group>
                </van-col>
                <van-col :span="24" class="login-input">
                    <van-cell-group>
                        <van-field type="password" clearable v-model="form.password" placeholder="请输入密码" />
                        <img class="smsCode" src="@/assets/images/login-code.png" alt="" />
                    </van-cell-group>
                </van-col>

            </van-row>
            <van-row class="submit">
                <van-col :span="24">
                    <van-button round type="info" class="login-btn" @click="tologin">登录</van-button>
                </van-col>
            </van-row>
        </div>

        <div class="recordNum">
            <span @click="openPrivacyPolicy">京ICP备2025123855号-3</span>
        </div>
    </div>
</template>

<script>
import { Notify } from "vant";
import { login } from "@/api/login";
export default {
    data() {
        const defaultForm = {
            username: null,
            password: null
        };
        return {
            defaultForm,
            form: { ...defaultForm },
        };
    },
    methods: {
        tologin() {
            login(this.form)
                .then((res) => {
                    Notify({ type: "success", message: res });
                    this.$router.push("/projectlist");
                })
                .catch((e) => {
                    Notify({ type: "warning", message: e.message });
                });
        },
        openPrivacyPolicy() {
            window.open("https://beian.miit.gov.cn");
        }
    },
};
</script>

<style lang="scss" scoped>
.login-bg {
    height: 406px;
    background: url(../../assets/images/login-bg.png) no-repeat center center;
    background-size: cover;

    p {
        color: #fff;
        padding-top: 80px;
    }
}

.login-form {
    margin: -220px 24px 0;
    background: #fff;
    border-radius: 20px;
    padding: 0 22px;
    height: 50vh;
    padding-top: 30px;

    .van-hairline--top-bottom::after {
        border: none;
    }

    .login-input {
        margin-top: 30px;

        .van-cell {
            background: #f6f6f6;
            border-radius: 20px;
        }

        img {
            position: absolute;
            left: 5vw;
            top: 50%;
            transform: translateY(-50%);
        }

        .van-field {
            padding-left: 50px;
        }
    }

    .submit {
        // position: fixed;
        // bottom: 100px;
        // left: 50%;
        // transform: translateX(-50%);
        width: 100%;

        transform: translateX(-8px);
        margin-top: 160px;
        background: #fff;

        .login-btn {
            width: 80vw;
            background: #2553e2;
        }
    }
}

.login-main {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
}

.phoneicon {
    width: 14px;
    height: 18px;
}

.smsCode {
    width: 16px;
    height: 19px;
}

.recordNum {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
}
</style>